import { Component, Input, OnInit } from "@angular/core";
import { ConfiguracionTarjetaInicio } from "app/main/apps/shared/models/configuracion-tarjeta-inicio.model";

@Component({
    selector: "app-tarjeta",
    templateUrl: "./tarjeta.component.html",
    styleUrls: ["./tarjeta.component.scss"],
})
export class TarjetaComponent implements OnInit {
    @Input() tarjeta: ConfiguracionTarjetaInicio;
    constructor() {}

    ngOnInit(): void {}
}
